export type HeliosMdiIconClass =
  | 'mdi-account-group'
  | 'mdi-account-multiple'
  | 'mdi-account'
  | 'mdi-account-edit'
  | 'mdi-alert'
  | 'mdi-alert-circle'
  | 'mdi-alert-circle-outline'
  | 'mdi-cancel'
  | 'mdi-check-circle'
  | 'mdi-check-outline'
  | 'mdi-checkbox-blank-outline'
  | 'mdi-checkbox-marked'
  | 'mdi-checkbox-marked-circle'
  | 'mdi-chevron-double-down'
  | 'mdi-chevron-double-up'
  | 'mdi-chevron-triple-up'
  | 'mdi-clipboard-check'
  | 'mdi-clock-outline'
  | 'mdi-close-circle-outline'
  | 'mdi-close-octagon'
  | 'mdi-currency-usd'
  | 'mdi-database'
  | 'mdi-file-multiple'
  | 'mdi-file'
  | 'mdi-file-multiple-outline'
  | 'mdi-file-outline'
  | 'mdi-help-circle'
  | 'mdi-help-box'
  | 'mdi-minus'
  | 'mdi-minus-box-outline'
  | 'mdi-pencil'
  | 'mdi-play'
  | 'mdi-shield-check'
  | 'mdi-cog'
  | 'mdi-timer-sand'
  | HeliosDragMdiIconClass
  | 'mdi-link'
  | 'mdi-link-off'

export type HeliosMdiIconModifierClass =
  | 'text-dark'
  | 'text-warning'
  | 'text-danger'
  | 'text-success'
  | 'text-muted'
  | 'text-primary'
  | 'text-orange'
  | 'text-purple'

export type HeliosDragMdiIconClass = 'mdi-drag-horizontal' | 'mdi-drag-vertical'

/** Generate mdi icons as html that can be consumed by ag-grid cell renderers. */
export function generateMdiIcon(
  iconClass: HeliosMdiIconClass,
  additionalClasses?: HeliosMdiIconModifierClass[],
) {
  return `<i class="mdi ${iconClass} ${
    additionalClasses ? additionalClasses.join(' ') : ''
  }"></i>`
}
